import Chart from "react-apexcharts";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import ReactECharts from "echarts-for-react";


const CoGenCostBreakdown = (props) => {

    const {currencySymbol, coGen} = props;

    const { t } = useTranslation();

    let x = []
    let y = []

    let totalCoGen = 0.0;
    let coGenData = [];
    coGen.generators?.forEach((item)=>{
        coGenData.push(({x: item.name, y: item.cost})); 
        totalCoGen += item.cost
        
    })
    
    if (coGen.grid > 0){
        coGenData.push({x:t("Grid"), y: coGen.grid})
        totalCoGen += coGen.grid
    }

    

    coGenData.sort((a, b)=>{return a.y - b.y }).map((item)=>{x.push(item.x); y.push(item.y)})
    

    
    

    const series = [
        {
          name: "Cost",
          data: y
        }
    ];

    
    const options = {
            xAxis: {
            },
            yAxis: {
                data: x,
            },
            grid: {
                left: 120,
                right: 35,
                top: 0,
                bottom: 40
            },
            tooltip: {
                show: true,
                formatter: function(params) {
                    return params.name + ': ' + currencySymbol + params.value.toFixed() 
                }
            },
            textStyle: {
                fontFamily: "Roboto, Helvetica, Arial, sans-serif" 
            },
            series: {
                type: "bar",
                data: y,
                itemStyle: {
                    color: '#3788d8'
                },
                label: {
                    show: true,  
                    position: 'inside',  
                    color: 'black',  
                    fontSize: 14,  
                    formatter: function (params) {
                        return Math.round(params.value * 100 / totalCoGen) + '%'  
                    },
                },
            }
        }
    


    return (
        <>
         <ReactECharts option={options} style={{ width: '100%', height: '100%' }}/> 
        </>
    )

}

export default CoGenCostBreakdown;